import PropTypes from 'prop-types';
import ChatGPTInterface from '../../../../ChatGPTInterface';
import useHotelExtractor from '../../../../ChatGPTInterface/extractors/hotelExtractor';
import { isQueryRelevantToHotel } from '../../../../ChatGPTInterface/helpers/isQueryRelevant';
import isQuerySensitive from '../../../../ChatGPTInterface/helpers/isQuerySensitive';
import { generateHotelGeneralIntroMessage } from '../../../../ChatGPTInterface/introMessages/hotelIntroMessage';
import {
  useNLPConstants,
  useNLPRelevantTerms,
  useNLPInstructions,
} from '../../../../ChatGPTInterface/constants/nlpSettings';

const HotelAskAiTab = ({ itinerary, tripId, travelOption }) => {
  const nlpConstants = useNLPConstants();
  const nlpRelevantTerms = useNLPRelevantTerms();
  const nlpInstructions = useNLPInstructions();

  return (
    <ChatGPTInterface
      rawData={{ itinerary, tripId, travelOption }}
      extractor={useHotelExtractor}
      utilFunctions={{
        isQueryRelevant: isQueryRelevantToHotel(nlpRelevantTerms),
        isQuerySensitive,
      }}
      disabled={false}
      generalIntro={generateHotelGeneralIntroMessage(itinerary, nlpConstants, nlpInstructions)}
      siteType="HOTEL"
      instructionName="Interface - Hotel Instruction"
    />
  );
};

HotelAskAiTab.propTypes = {
  itinerary: PropTypes.shape().isRequired,
  tripId: PropTypes.string,
  travelOption: PropTypes.shape({
    key: PropTypes.string,
    mode: PropTypes.number,
  }),
};

HotelAskAiTab.defaultProps = {
  tripId: '',
  travelOption: {},
};

export default HotelAskAiTab;
